module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.25a32416.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/font-awesome-4.6.3/fonts/fontawesome-webfont.eot
 ** module id = 1356
 ** module chunks = 0
 **/